import Nullstack from 'nullstack';
export default function IconGizmo({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-gizmo",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20 19l-8 -5.5l-8 5.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 4v9.5"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "4",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "4",
    cy: "19",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "20",
    cy: "19",
    r: "1"
  }), " ");
}